import { Injectable, inject, computed } from '@angular/core';
import { AppCartItemsService } from './app-cart-items.service';
import { AppRequestContextService } from './app-request-context.service';
import {
  CartPromotionsEngine,
  toCartPromotionsEngineProducts,
} from '@pedix-workspace/angular-shared-order';
import { getEstablishmentTimezone } from '@pedix-workspace/utils';
import { StockService } from '@pedix-workspace/pedixapp-stock';

@Injectable({ providedIn: 'root' })
export class CartPromotionsService {
  private cartItemsService = inject(AppCartItemsService);
  private appRequestContext = inject(AppRequestContextService);
  private stockService = inject(StockService);

  private readonly establishmentTimezone = computed(() =>
    getEstablishmentTimezone(this.appRequestContext.establishment()),
  );

  // `allProducts` y no `products`: el motor resuelve ítems del CARRITO, que pueden haber sido
  // ocultados —o su categoría desactivada— después de agregarse
  private readonly engineProducts = computed(() =>
    toCartPromotionsEngineProducts(this.appRequestContext.allProducts()),
  );

  private engine = new CartPromotionsEngine({
    cartItems: this.cartItemsService.cartItems,
    promotions: this.appRequestContext.promotions,
    products: this.engineProducts,
    timezone: this.establishmentTimezone,
    stock: this.stockService.stock,
  });

  readonly totalDiscount = this.engine.totalDiscount;
  readonly participatingPromotionsByProductId = this.engine.participatingPromotionsByProductId;
  readonly availablePromotionsByProductId = this.engine.availablePromotionsByProductId;
  readonly savingsByProductId = this.engine.savingsByProductId;
  readonly upsellHintsByCartItemId = this.engine.upsellHintsByCartItemId;
}
